const type = "changeValueForFreeShipping"

const changeValueForFreeShipping = objeto => {
    return {
        type,
        payload: objeto
    }
}

module.exports = {
    changeValueForFreeShipping
}